// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=414-9993
// Figma component name: TripType
// Replaces: IconSwitch for the isCompanyTrip field in SelectHow

import classnames from 'classnames'

// Person icon — filled black when selected, gray outline when not
function PersonIcon({ selected }) {
  if (selected) {
    return (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M10 12.5C7.35827 12.5 5.009 13.7755 3.51333 15.755C3.19142 16.181 3.03047 16.394 3.03573 16.6819C3.0398 16.9043 3.17947 17.1849 3.35447 17.3222C3.58099 17.5 3.89489 17.5 4.52269 17.5H15.4773C16.1051 17.5 16.419 17.5 16.6455 17.3222C16.8205 17.1849 16.9602 16.9043 16.9643 16.6819C16.9695 16.394 16.8086 16.181 16.4867 15.755C14.991 13.7755 12.6417 12.5 10 12.5Z" fill="#17181A" stroke="#17181A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 10C12.0711 10 13.75 8.32107 13.75 6.25C13.75 4.17893 12.0711 2.5 10 2.5C7.92893 2.5 6.25 4.17893 6.25 6.25C6.25 8.32107 7.92893 10 10 10Z" fill="#17181A" stroke="#17181A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M10 12.5C7.35827 12.5 5.009 13.7755 3.51333 15.755C3.19142 16.181 3.03047 16.394 3.03573 16.6819C3.0398 16.9043 3.17947 17.1849 3.35447 17.3222C3.58099 17.5 3.89489 17.5 4.52269 17.5H15.4773C16.1051 17.5 16.419 17.5 16.6455 17.3222C16.8205 17.1849 16.9602 16.9043 16.9643 16.6819C16.9695 16.394 16.8086 16.181 16.4867 15.755C14.991 13.7755 12.6417 12.5 10 12.5Z" stroke="#5D5D5F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 10C12.0711 10 13.75 8.32107 13.75 6.25C13.75 4.17893 12.0711 2.5 10 2.5C7.92893 2.5 6.25 4.17893 6.25 6.25C6.25 8.32107 7.92893 10 10 10Z" stroke="#5D5D5F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

// Company/briefcase icon — filled black when selected, gray outline when not
function CompanyIcon({ selected }) {
  if (selected) {
    return (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M1.66667 8.5C1.66667 7.56658 1.66667 7.09987 1.84832 6.74335C2.00811 6.42975 2.26308 6.17478 2.57668 6.01499C2.9332 5.83333 3.39991 5.83333 4.33333 5.83333H15.6667C16.6001 5.83333 17.0668 5.83333 17.4233 6.01499C17.7369 6.17478 17.9919 6.42975 18.1517 6.74335C18.3333 7.09987 18.3333 7.56658 18.3333 8.5V14.8333C18.3333 15.7668 18.3333 16.2335 18.1517 16.59C17.9919 16.9036 17.7369 17.1586 17.4233 17.3183C17.0668 17.5 16.6001 17.5 15.6667 17.5H4.33333C3.39991 17.5 2.9332 17.5 2.57668 17.3183C2.26308 17.1586 2.00811 16.9036 1.84832 16.59C1.66667 16.2335 1.66667 15.7668 1.66667 14.8333V8.5Z" fill="#17181A" stroke="#17181A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.3333 5.83333C13.3333 5.05836 13.3333 4.67087 13.2481 4.35295C13.017 3.49022 12.3431 2.81635 11.4804 2.58519C11.1625 2.5 10.775 2.5 10 2.5C9.22502 2.5 8.83754 2.5 8.51962 2.58519C7.65689 2.81635 6.98302 3.49022 6.75185 4.35295C6.66667 4.67087 6.66667 5.05836 6.66667 5.83333" stroke="#17181A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M13.3333 5.83333C13.3333 5.05836 13.3333 4.67087 13.2481 4.35295C13.017 3.49022 12.3431 2.81635 11.4804 2.58519C11.1625 2.5 10.775 2.5 10 2.5C9.22502 2.5 8.83754 2.5 8.51962 2.58519C7.65689 2.81635 6.98302 3.49022 6.75185 4.35295C6.66667 4.67087 6.66667 5.05836 6.66667 5.83333M4.33333 17.5H15.6667C16.6001 17.5 17.0668 17.5 17.4233 17.3183C17.7369 17.1586 17.9919 16.9036 18.1517 16.59C18.3333 16.2335 18.3333 15.7668 18.3333 14.8333V8.5C18.3333 7.56658 18.3333 7.09987 18.1517 6.74335C17.9919 6.42975 17.7369 6.17478 17.4233 6.01499C17.0668 5.83333 16.6001 5.83333 15.6667 5.83333H4.33333C3.39991 5.83333 2.9332 5.83333 2.57668 6.01499C2.26308 6.17478 2.00811 6.42975 1.84832 6.74335C1.66667 7.09987 1.66667 7.56658 1.66667 8.5V14.8333C1.66667 15.7668 1.66667 16.2335 1.84832 16.59C2.00811 16.9036 2.26308 17.1586 2.57668 17.3183C2.9332 17.5 3.39991 17.5 4.33333 17.5Z" stroke="#5D5D5F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

/**
 * TripTypeSwitch — Formik field component for the private / company trip toggle.
 * Renders a label row (title + info subtitle) on the left and the pill toggle on the right.
 *
 * Props (Formik field component interface):
 *   field.value  boolean — false = Private, true = Company
 *   form         Formik form helpers
 *   title        string — label above the subtitle (e.g. "Private or company trip?")
 *   info         string — subtitle text (e.g. company name or "Private")
 *   disabled     boolean — locks the toggle
 */
export default function TripTypeSwitch({ field, form, title, info, disabled }) {
  const isCompany = Boolean(field.value)

  const handleSelect = (selectCompany) => {
    if (disabled) return
    form.setFieldValue(field.name, selectCompany)
    form.setFieldTouched(field.name, true, false)
  }

  return (
    <div className={classnames(
      'flex items-center w-full py-3',
      disabled && 'opacity-50 pointer-events-none',
    )}>
      {/* Left: text column */}
      <div className="flex flex-col gap-1 flex-1 min-w-0">
        {title && (
          <p className="text-[16px] font-semibold uppercase tracking-[0.32px] leading-6 text-on-surface whitespace-nowrap">
            {title}
          </p>
        )}
        {info && (
          <p className="text-[15px] leading-5 text-on-surface-variant">
            {info}
          </p>
        )}
      </div>

      {/* Right: sliding pill toggle */}
      <div
        className="relative inline-flex items-center rounded-[24px] border-solid border-[0.5px] border-outline bg-[#fafafa] shrink-0"
      >
        {/* Sliding yellow indicator */}
        <div
          aria-hidden="true"
          className={classnames(
            'absolute top-0 left-0 w-12 h-12 rounded-full',
            'bg-secondary-container border-solid border-[0.5px] border-secondary',
            'transition-transform duration-200 ease-in-out',
            isCompany && 'translate-x-full',
          )}
        />

        {/* Private (person) button */}
        <button
          type="button"
          onClick={() => handleSelect(false)}
          disabled={disabled}
          aria-pressed={!isCompany}
          aria-label="Private trip"
          className="relative z-10 flex w-12 h-12 items-center justify-center rounded-full shrink-0"
        >
          <PersonIcon selected={!isCompany} />
        </button>

        {/* Company (briefcase) button */}
        <button
          type="button"
          onClick={() => handleSelect(true)}
          disabled={disabled}
          aria-pressed={isCompany}
          aria-label="Company trip"
          className="relative z-10 flex w-12 h-12 items-center justify-center rounded-full shrink-0"
        >
          <CompanyIcon selected={isCompany} />
        </button>
      </div>
    </div>
  )
}
